/**
 * Workflow extension manifest — ACTION plugins + layers (engine / api / web).
 * Keep in sync with WORKFLOW_AUTOMATION_ACTION_REGISTRY.
 */
import { WORKFLOW_AUTOMATION_ACTION_REGISTRY } from './workflow-automation-action.registry.js';

const ticketOnlyActions = new Set(['ticket-transition', 'ticket-assign']);

/** @typedef {'engine'|'api'|'web'} PluginLayer */

/**
 * @typedef {{
 *   id: string,
 *   eventName: string,
 *   layers: PluginLayer[],
 *   entityTypes?: string[],
 *   designer?: boolean,
 *   listenerStatus?: string,
 * }} WorkflowActionPluginManifest
 */

/** @type {WorkflowActionPluginManifest[]} */
export const WORKFLOW_ACTION_PLUGIN_MANIFEST = WORKFLOW_AUTOMATION_ACTION_REGISTRY.map((e) => ({
    id: e.actionType,
    eventName: e.eventName,
    layers: /** @type {PluginLayer[]} */ (['engine', 'api']),
    entityTypes: ticketOnlyActions.has(e.actionType) ? ['Ticket'] : undefined,
    designer: e.designerForm,
    listenerStatus: e.listenerStatus,
}));

export function getActionPluginManifest(actionType) {
    return WORKFLOW_ACTION_PLUGIN_MANIFEST.find((p) => p.id === actionType) || null;
}

export function listActionPluginIds() {
    return WORKFLOW_ACTION_PLUGIN_MANIFEST.map((p) => p.id);
}
